import axios from 'axios';

async function ProcesarPadron(prmFileName: string, prmContenido: string) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/procesar_padron"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "padron": {
                "nombre": prmFileName,
                "contenido": prmContenido
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ProcesarPadron;